(()=>{
  const ROOT='[data-epc-root]';

  function getParts(root){
    return {
      viewport:root.querySelector('[data-epc-viewport]'),
      track:root.querySelector('[data-epc-track]'),
      slides:[...root.querySelectorAll('[data-epc-slide]')],
      prev:root.querySelector('[data-epc-prev]'),
      next:root.querySelector('[data-epc-next]')
    };
  }

  function maxOffset(parts){
    if(!parts.viewport||!parts.slides.length)return 0;
    const last=parts.slides[parts.slides.length-1];
    return Math.max(0,last.offsetLeft+last.offsetWidth-parts.viewport.clientWidth);
  }

  function maxIndex(parts){
    const max=maxOffset(parts);
    if(max<=1)return 0;
    let idx=0;
    for(let i=0;i<parts.slides.length;i++){
      if(parts.slides[i].offsetLeft<=max+1)idx=i;
      else break;
    }
    if(parts.slides[idx]&&parts.slides[idx].offsetLeft<max-1&&idx<parts.slides.length-1)idx++;
    return Math.min(idx,parts.slides.length-1);
  }

  function apply(root,index,animate=true){
    const parts=getParts(root);
    if(!parts.track||!parts.slides.length)return;
    const lastIndex=maxIndex(parts);
    root._epcIndex=Math.max(0,Math.min(index,lastIndex));
    const target=parts.slides[root._epcIndex];
    const offset=Math.min(target?target.offsetLeft:0,maxOffset(parts));
    if(!animate)parts.track.style.transition='none';
    parts.track.style.transform=`translate3d(${-offset}px,0,0)`;
    if(!animate){parts.track.getBoundingClientRect();parts.track.style.transition='';}
    if(parts.prev){parts.prev.disabled=root._epcIndex<=0;parts.prev.setAttribute('aria-disabled',parts.prev.disabled?'true':'false');}
    if(parts.next){parts.next.disabled=root._epcIndex>=lastIndex;parts.next.setAttribute('aria-disabled',parts.next.disabled?'true':'false');}
    root.classList.toggle('epc-is-locked',lastIndex===0);
  }

  function bindNav(root){
    const {prev,next}=getParts(root);
    prev?.addEventListener('click',e=>{e.preventDefault();if(!prev.disabled)apply(root,(root._epcIndex||0)-1,true)});
    next?.addEventListener('click',e=>{e.preventDefault();if(!next.disabled)apply(root,(root._epcIndex||0)+1,true)});
  }

  function bindSwipe(root){
    const viewport=root.querySelector('[data-epc-viewport]');
    if(!viewport)return;
    let x=0,y=0,tracking=false;
    viewport.addEventListener('touchstart',e=>{const t=e.touches?.[0];if(!t)return;x=t.clientX;y=t.clientY;tracking=true},{passive:true});
    viewport.addEventListener('touchend',e=>{if(!tracking)return;tracking=false;const t=e.changedTouches?.[0];if(!t)return;const dx=t.clientX-x,dy=t.clientY-y;if(Math.abs(dx)<viewport.clientWidth*.12||Math.abs(dx)<=Math.abs(dy))return;apply(root,(root._epcIndex||0)+(dx<0?1:-1),true)},{passive:true});
  }

  function bindSwatches(root){
    root.querySelectorAll('[data-epc-card]').forEach(card=>{
      card.querySelectorAll('[data-epc-swatch]').forEach(btn=>{
        btn.addEventListener('click',()=>{
          card.querySelectorAll('[data-epc-swatch]').forEach(x=>x.classList.toggle('is-active',x===btn));
          const colorLabel=card.querySelector('[data-epc-color-label]');
          if(colorLabel&&btn.dataset.colorName)colorLabel.textContent=btn.dataset.colorName;
          const img=card.querySelector('.epc-card__image');
          if(img&&btn.dataset.imageUrl){img.src=btn.dataset.imageUrl;img.removeAttribute('srcset');}
          const input=card.querySelector('[data-epc-variant-input]');
          if(input&&btn.dataset.variantId)input.value=btn.dataset.variantId;
          const productLink=card.querySelector('[data-epc-product-link]');
          const viewLink=card.querySelector('[data-epc-view-link]');
          const klarnaPlacement=card.querySelector('[data-epc-klarna-placement]');
          if(btn.dataset.variantUrl){
            if(productLink)productLink.href=btn.dataset.variantUrl;
            if(viewLink)viewLink.href=btn.dataset.variantUrl;
          }
          if(klarnaPlacement&&btn.dataset.priceAmount){
            klarnaPlacement.setAttribute('data-purchase-amount',btn.dataset.priceAmount);
            scheduleKlarnaRefresh();
          }
          const price=card.querySelector('[data-epc-price]');
          if(price&&btn.dataset.price)price.textContent=btn.dataset.price;
          const compare=card.querySelector('[data-epc-compare-price]');
          if(compare){compare.textContent=btn.dataset.comparePrice||'';compare.classList.toggle('is-hidden',!btn.dataset.comparePrice);}
          const sale=card.querySelector('[data-epc-sale-badge]');
          if(sale){sale.textContent=btn.dataset.save?`${btn.dataset.save} OFF`:'';sale.hidden=!btn.dataset.save;}
        });
      });
    });
  }

  let klarnaRefreshTimer;
  function scheduleKlarnaRefresh(){
    window.clearTimeout(klarnaRefreshTimer);
    klarnaRefreshTimer=window.setTimeout(()=>{
      try{window.Klarna?.OnsiteMessaging?.refresh?.();}catch(_){ }
    },80);
  }


  function init(root){
    if(!root||root._epcBound)return;
    root._epcBound=true;
    root._epcIndex=0;
    bindNav(root);bindSwipe(root);bindSwatches(root);apply(root,0,false);
    let timer;
    window.addEventListener('resize',()=>{clearTimeout(timer);timer=setTimeout(()=>apply(root,root._epcIndex||0,false),120)},{passive:true});
  }

  function boot(scope=document){
    const roots=scope.matches?.(ROOT)?[scope]:[...(scope.querySelectorAll?.(ROOT)||[])];
    roots.forEach(init);
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>boot()):boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
